<template>
  <div class="print">
    <header-top :headerText="headerText" showBack></header-top>
    <!-- <div class="print-main">
      <div class="print-box">
        <div class="work-card" id="workCard">
          <img :src="workCardBg" class="bg-img" />
          <div class="card-box">
            <img :src="workCardLogo" class="logo-img" />
            <img :src="headImg" class="head-img" />
            <div class="form-box">
              <div class="form-item">
                <span>姓名：</span>
                <div class="item-value">{{employe.name}}</div>
              </div>
              <div class="form-item">
                <span>部门：</span>
                <div class="item-value">{{employe.department}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="line"></div>
        <div class="group-btn">
          <el-button type="primary" v-print="'#workCard'">立即打印</el-button>
        </div>
      </div>
    </div>-->
    <div class="print-main" v-loading="loading">
      <div class="print-box">
        <div class="work-card" id="workCard">
          <img :src="printBg" class="bg-img" />
          <div class="card-box">
            <img :src="employe.photoUrl" class="head-img" />
            <div class="name-box">{{employe.name}}</div>
            <div class="form-box">
              <div class="item-value">{{employe.organizationUnit}}</div>
              <div class="item-value">{{employe.phoneNumber}}</div>
            </div>
          </div>
        </div>
        <div class="line"></div>
        <div class="group-btn">
          <el-button type="primary" v-print="'#workCard'">打印</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import { getUserDetails } from "@/http/api/employe";
export default {
  components: {
    headerTop,
  },
  data() {
    return {
      headerText: "打印工牌",
      // workCardBg: require("../../../../../assets/image/work-card-bg.png"),
      // workCardLogo: require("../../../../../assets/image/work-card-logo.png"),
      printBg: require("../../../../../assets/image/print-bg.png"),
      headImg: require("../../../../../assets/image/default-head.png"),
      employe: {},
      loading:true
    };
  },
  mounted() {
    // 获取员工信息
    getUserDetails(this.$route.params.id)
      .then((res) => {
        this.employe = res.result;
        this.loading=false;
      })
  },
};
</script>

<style lang="scss" scoped>
// .print {
//   .print-main {
//     height: calc(100ch - 110px);
//     padding: 20px 180px;
//     box-sizing: border-box;
//     background-color: #f2f2f2;

//     .print-box {
//       overflow: hidden;
//       padding: 20px;
//       width: 100%;
//       background: #fff;
//       box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);

//       .work-card {
//         margin: 20px auto 30px;
//         position: relative;
//         width: 205px;
//         height: 339px;

//         box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);

//         .bg-img {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 205px;
//           height: 339px;
//         }

//         .card-box {
//           position: relative;
//           overflow: hidden;
//           width: 100%;
//           height: 100%;
//           z-index: 2;

//           .logo-img {
//             display: block;
//             margin: 20px auto 0;
//             height: 60px;
//           }

//           .head-img {
//             display: block;
//             height: 90px;
//             margin: 40px auto 56px;
//           }

//           .form-box {
//             display: flex;
//             flex-direction: column;
//             align-items: center;

//             font-size: 12px;
//             font-weight: bold;
//             color: #000;

//             .form-item {
//               display: flex;
//               width: 137px;

//               .item-value {
//                 border-bottom: 1px solid #000;
//                 width: 100px;
//                 text-align: center;
//               }

//               &:first-child {
//                 margin-bottom: 15px;
//               }
//             }
//           }
//         }
//       }

//       .line {
//         margin-bottom: 20px;
//         width: 100%;
//         height: 1px;
//         background: #ddd;
//       }

//       .group-btn {
//         width: 100%;
//         text-align: center;
//       }
//     }
//   }
// }

.print {
  .print-main {
    height: calc(100ch - 110px);
    padding: 20px 180px;
    box-sizing: border-box;
    background-color: #f2f2f2;

    .print-box {
      overflow: hidden;
      padding: 20px;
      width: 100%;
      background: #fff;
      box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);

      .work-card {
        margin: 20px auto 30px;
        position: relative;
        width: 205px;
        height: 339px;
        box-shadow: 0px -1px 3px 0px #565656;

        .bg-img {
          position: absolute;
          top: 0;
          left: 0;
          width: 205px;
          height: 339px;
        }

        .card-box {
          position: relative;
          overflow: hidden;
          width: 100%;
          height: 100%;
          z-index: 2;
          font-size: 12px;

          .head-img {
            display: block;
            height: 147px;
            width: 107px;
            margin: 60px 0 55px 17px;
          }

          .name-box {
            position: absolute;
            right: 52px;
            top: 85px;
            width: 15px;
            font-size: 15px;
            font-weight: bold;
          }

          .form-box {
            position: relative;
            width: 100%;
            height: 50px;

            color: #fff;

            .item-value {
              margin-left: 45px;
              margin-bottom: 11px;
            }
          }
        }
      }

      .line {
        margin-bottom: 20px;
        width: 100%;
        height: 1px;
        background: #ddd;
      }

      .group-btn {
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>
<style lang="scss">
@media print {
  .work-card {
    margin: 20px auto 30px;
    position: relative;
    width: 205px;
    height: 339px;
    box-shadow: 0px -1px 3px 0px #565656;

    .bg-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 205px;
      height: 339px;
    }

    .card-box {
      position: relative;
      overflow: hidden;
      width: 100%;
      height: 100%;
      z-index: 2;
      font-size: 12px;

      .head-img {
        display: block;
        height: 147px;
        width: 107px;
        margin: 60px 0 55px 17px;
      }

      .name-box {
        position: absolute;
        right: 52px;
        top: 85px;
        width: 15px;
        font-size: 15px;
        font-weight: bold;
      }

      .form-box {
        position: relative;
        width: 100%;
        height: 50px;

        color: #fff;

        .item-value {
          margin-left: 45px;
          margin-bottom: 11px;
        }
      }
    }
  }
}
</style>